export default {
	PRODUCTS: 'companies/:company_id/products/',
	GET_RENT_PRODUCT: 'companies/:company_id/products/get-rent-product',
	SEARCH_PRODUCTS: 'companies/:company_id/products/list',
	GET_PRODUCTS_BY_TYPE: 'companies/:company_id/products/get-product-by-type/',
	// PRODUCT_LIST: 'products/get-product-list'
}
